import colors from '@/styles/colors'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const UserDetailsContent = styled(Box)({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  overflow: 'visible',
  '& .username': {
    overflowWrap: 'break-word',
  },
  '& .motto': {
    overflowWrap: 'break-word',
  },
  '& .preview-image': {
    minWidth: 130,
    height: 130,
    marginRight: 10,
    borderRadius: 12,
    objectFit: 'cover',
    boxShadow: '0 4px 12px rgba(15, 23, 42, 0.08)',
  },
  '& .view-tab': {
    borderBottom: `1px solid #e2e8f0`,
    borderTop: `1px solid #e2e8f0`,
  },
  '& .accept-icon-btn': {
    backgroundColor: colors.green,
    color: 'white',
    borderRadius: 12,
    '&:hover': {
      backgroundColor: `${colors.green}AA`,
    },
  },
  '& .reject-icon-btn': {
    backgroundColor: `${colors.error}AA`,
    color: colors.error,
    borderRadius: 12,
    '&:hover': {
      backgroundColor: `${colors.error}66`,
    },
  },
})
